<template>
  <div class="-gif">
    <div class="-thumbnail-wrapper">
      <div class="-thumbnail" @click="previewAsset">
        <wt-asset-overlay></wt-asset-overlay>
        <a href="#"><img :src="mixinSrc(src)" /></a>
        <slot name="checkmark"></slot>
      </div>
      <footer v-if="!inGifTab" :title="footerTitle">
        <span class="-title">{{ footerTitle }}</span>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  props: {
    searchContextId: {
      type: String,
      required: true,
    },
  },
  computed: {
    src: function () {
      return this.asset.metadata.animatedGifUrl;
    },
    footerTitle() {
      return _.isEmpty((this.asset.metadata.title || '').trim())
        ? this.asset.metadata.caption
        : this.asset.metadata.title;
    },
    inGifTab() {
      return this.searchContextId === 'GIF';
    },
  },
});
</script>
